var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDate(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 3.05176e-05C3.77614 3.05176e-05 4 0.223888 4 0.500031V1.00003H12V0.500031C12 0.223888 12.2239 3.05176e-05 12.5 3.05176e-05C12.7761 3.05176e-05 13 0.223888 13 0.500031V1.00003H14C15.1046 1.00003 16 1.89546 16 3.00003V14C16 15.1046 15.1046 16 14 16H2C0.895431 16 0 15.1046 0 14V3.00003C0 1.89546 0.895431 1.00003 2 1.00003H3V0.500031C3 0.223888 3.22386 3.05176e-05 3.5 3.05176e-05ZM1 4.00003V14C1 14.5523 1.44772 15 2 15H14C14.5523 15 15 14.5523 15 14V4.00003H1Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDate);
export default __webpack_public_path__ + "static/media/Date.6c565f3d19153e448bafbe377de1168b.svg";
export { ForwardRef as ReactComponent };